import axios from 'axios'

export default function(store) {
  // REQUEST
  axios.interceptors.request.use(function(config) {
    config.headers = config.headers || {}

    // AUTH
    let token = store.state.users.csrfToken
    if (token) {
      config.headers['X-CSRF-Token'] = token
    }
    config.withCredentials = true

    // Config for POST
    switch (config.method) {
      case 'patch':
      case 'post':
        config.headers['Content-Type'] = 'application/json'
        break
    }

    return config
  })

  // RESPONSE
  axios.interceptors.response.use(function(response) {
    return response.data
  }, function(errorObj) {
    if (errorObj.response.status === 401) {
      // The user session is not valid or expired
      store.dispatch('logout')
    }
    return Promise.reject(errorObj.response.data)
  })
}



// WEBPACK FOOTER //
// ./src/configAxios.js